import Svg from '@doordash/component-svg'
import * as React from 'react'
import { ImageProps } from '../'
import t from './strings'

// tslint:disable:max-line-length
export const Flexible: React.FunctionComponent<ImageProps> = ({
  width,
  height,
}) => (
  <Svg
    width={width}
    height={height}
    viewBox="0 0 81 78"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-labelledby="valuePropsTitleFlexible valuePropsDescFlexible"
    role="img"
  >
    <title id="valuePropsTitleFlexible">{t.title()}</title>
    <desc id="valuePropsDescFlexible">{t.desc()}</desc>
    <path
      d="M10.2324 59.0921C9.84347 59.4806 9.5598 64.5028 9.70146 65.5811C9.84313 66.6595 71.2558 66.469 71.5973 65.4006C71.9389 64.3312 70.3879 58.8977 70.3879 58.8977C70.3879 58.8977 10.6192 58.7043 10.2324 59.0921Z"
      fill="#C7C6B6"
    />
    <path
      d="M11.4165 13.0449L8.43379 63.4104L72.8586 63.4096L68.0773 13.0449L11.4165 13.0449Z"
      fill="#EAE9DC"
    />
    <path
      d="M16 14.8261C16.0999 15.0486 16.1305 15.3087 16.0741 15.5757C16.0128 15.8675 15.8417 16.0761 15.5638 16.1859C15.104 16.3689 14.6589 16.359 14.2456 16.0573C14.0952 15.9466 13.9746 15.8081 13.9083 15.6321C13.8717 15.5371 13.8589 15.4343 13.8668 15.3334C13.8876 15.0407 13.9499 14.7578 14.113 14.5076C14.2357 14.3187 14.4127 14.1981 14.6332 14.1467C15.1218 14.0349 15.6212 14.1862 15.9021 14.6233C15.9377 14.6797 15.9584 14.741 16 14.8261Z"
      fill="#C7C6B6"
    />
    <path
      d="M20.8695 14.8793C20.9694 15.1018 21.0001 15.3619 20.9437 15.629C20.8824 15.9207 20.7113 16.1284 20.4344 16.2391C19.9735 16.4211 19.5295 16.4112 19.1161 16.1096C18.9648 15.9998 18.8451 15.8614 18.7779 15.6843C18.7423 15.5894 18.7284 15.4865 18.7363 15.3867C18.7571 15.0939 18.8194 14.8111 18.9826 14.5609C19.1052 14.371 19.2823 14.2503 19.5028 14.1999C19.9913 14.0872 20.4908 14.2395 20.7716 14.6766C20.8072 14.732 20.828 14.7943 20.8695 14.8793Z"
      fill="#C7C6B6"
    />
    <path
      d="M26.1086 15.1483C26.2084 15.3708 26.2391 15.6309 26.1827 15.8979C26.1224 16.1897 25.9503 16.3983 25.6734 16.5081C25.2126 16.6901 24.7685 16.6812 24.3551 16.3795C24.2038 16.2688 24.0842 16.1303 24.0169 15.9533C23.9813 15.8593 23.9685 15.7565 23.9754 15.6556C23.9961 15.3629 24.0594 15.08 24.2216 14.8298C24.3452 14.64 24.5223 14.5203 24.7418 14.4689C25.2304 14.3571 25.7298 14.5084 26.0107 14.9455C26.0463 15.0019 26.067 15.0632 26.1086 15.1483Z"
      fill="#C7C6B6"
    />
    <path
      d="M31.7497 15.143C31.8496 15.3655 31.8802 15.6256 31.8238 15.8926C31.7625 16.1843 31.5914 16.393 31.3135 16.5028C30.8537 16.6857 30.4086 16.6759 29.9953 16.3742C29.8449 16.2635 29.7243 16.126 29.658 15.949C29.6224 15.854 29.6086 15.7512 29.6165 15.6503C29.6373 15.3576 29.6996 15.0747 29.8627 14.8245C29.9854 14.6356 30.1624 14.515 30.3829 14.4635C30.8715 14.3518 31.3709 14.5031 31.6518 14.9412C31.6874 14.9966 31.7081 15.0579 31.7497 15.143Z"
      fill="#C7C6B6"
    />
    <path
      d="M36.9784 15.143C37.0783 15.3655 37.109 15.6256 37.0526 15.8926C36.9913 16.1843 36.8202 16.393 36.5423 16.5028C36.0824 16.6857 35.6374 16.6759 35.224 16.3742C35.0737 16.2635 34.953 16.126 34.8868 15.949C34.8512 15.854 34.8373 15.7512 34.8453 15.6503C34.866 15.3576 34.9283 15.0747 35.0915 14.8245C35.2141 14.6356 35.3912 14.515 35.6117 14.4635C36.1002 14.3518 36.5997 14.5031 36.8805 14.9412C36.9161 14.9966 36.9369 15.0579 36.9784 15.143Z"
      fill="#C7C6B6"
    />
    <path
      d="M41.9643 15.4497C42.0642 15.6722 42.0949 15.9323 42.0385 16.1993C41.9782 16.4911 41.8061 16.6988 41.5292 16.8095C41.0683 16.9915 40.6243 16.9816 40.2109 16.68C40.0596 16.5702 39.9399 16.4317 39.8727 16.2547C39.8371 16.1598 39.8232 16.0569 39.8311 15.957C39.8519 15.6643 39.9152 15.3815 40.0774 15.1312C40.2 14.9414 40.378 14.8207 40.5976 14.7703C41.0861 14.6575 41.5856 14.8098 41.8664 15.247C41.902 15.3023 41.9228 15.3646 41.9643 15.4497Z"
      fill="#C7C6B6"
    />
    <path
      d="M47.573 15.4497C47.6729 15.6722 47.7036 15.9323 47.6472 16.1993C47.5869 16.4911 47.4148 16.6988 47.1379 16.8095C46.677 16.9915 46.233 16.9816 45.8196 16.68C45.6683 16.5702 45.5486 16.4317 45.4814 16.2547C45.4458 16.1598 45.4329 16.0569 45.4399 15.957C45.4606 15.6643 45.5239 15.3815 45.6861 15.1312C45.8097 14.9414 45.9867 14.8207 46.2063 14.7703C46.6948 14.6575 47.1943 14.8098 47.4751 15.247C47.5107 15.3023 47.5315 15.3646 47.573 15.4497Z"
      fill="#C7C6B6"
    />
    <path
      d="M53.246 15.5976C53.3458 15.8201 53.3765 16.0802 53.3201 16.3472C53.2588 16.639 53.0877 16.8466 52.8098 16.9574C52.35 17.1394 51.9049 17.1305 51.4915 16.8278C51.3412 16.7181 51.2206 16.5796 51.1543 16.4026C51.1177 16.3077 51.1049 16.2058 51.1128 16.1049C51.1335 15.8122 51.1958 15.5293 51.359 15.2791C51.4817 15.0893 51.6587 14.9686 51.8792 14.9182C52.3678 14.8054 52.8672 14.9577 53.1481 15.3948C53.1837 15.4502 53.2044 15.5125 53.246 15.5976Z"
      fill="#C7C6B6"
    />
    <path
      d="M59.5201 15.5976C59.62 15.8201 59.6506 16.0802 59.5943 16.3472C59.5339 16.639 59.3619 16.8466 59.0849 16.9574C58.6241 17.1394 58.18 17.1305 57.7667 16.8278C57.6154 16.7181 57.4957 16.5796 57.4284 16.4026C57.3928 16.3077 57.38 16.2058 57.3869 16.1049C57.4077 15.8122 57.471 15.5293 57.6332 15.2791C57.7568 15.0893 57.9338 14.9686 58.1533 14.9182C58.6419 14.8054 59.1413 14.9577 59.4222 15.3948C59.4578 15.4502 59.4786 15.5125 59.5201 15.5976Z"
      fill="#C7C6B6"
    />
    <path
      d="M65.193 15.4497C65.2929 15.6722 65.3235 15.9323 65.2672 16.1993C65.2058 16.4911 65.0347 16.6988 64.7569 16.8095C64.297 16.9915 63.852 16.9816 63.4386 16.68C63.2882 16.5702 63.1676 16.4317 63.1013 16.2547C63.0647 16.1598 63.0519 16.0569 63.0598 15.957C63.0806 15.6643 63.1429 15.3815 63.306 15.1312C63.4287 14.9414 63.6057 14.8207 63.8262 14.7703C64.3148 14.6575 64.8142 14.8098 65.0951 15.247C65.1307 15.3023 65.1514 15.3646 65.193 15.4497Z"
      fill="#C7C6B6"
    />
    <path
      d="M15.0265 10.8367L14.8693 15.018"
      stroke="#2D656F"
      strokeWidth="0.0018"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M58.6949 11.0849L58.5387 15.2673"
      stroke="#2D656F"
      strokeWidth="0.0018"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M41.1283 11.0849L40.972 15.2673"
      stroke="#2D656F"
      strokeWidth="0.0018"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M19.9384 10.8472L19.7821 15.0296"
      stroke="#2D656F"
      strokeWidth="0.0018"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M52.3042 11.2064L52.1479 15.3888"
      stroke="#2D656F"
      strokeWidth="0.0018"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M25.125 10.9581L24.9687 15.1405"
      stroke="#2D656F"
      strokeWidth="0.0018"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M46.6951 11.5074L46.5388 15.6898"
      stroke="#2D656F"
      strokeWidth="0.0018"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M64.1878 11.4493L64.0315 15.6317"
      stroke="#2D656F"
      strokeWidth="0.0018"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M30.1742 10.9634L30.4056 15.1443"
      stroke="#2D656F"
      strokeWidth="0.0018"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M14.9155 22.2282C14.4213 22.4753 13.1847 53.8633 13.803 54.1114C14.8915 54.547 66.819 54.2344 67.1885 53.7401C67.5598 53.2468 65.2122 22.4753 64.7176 22.1044C64.2229 21.7334 15.4103 21.9802 14.9155 22.2282Z"
      stroke="white"
      strokeWidth="0.00142857"
      strokeMiterlimit="10"
    />
    <path
      d="M21.9637 22.0415C21.5961 24.4308 21.4079 54.2946 21.4079 54.2946"
      stroke="white"
      strokeWidth="0.00142857"
      strokeMiterlimit="10"
    />
    <path
      d="M28.8902 22.4146C28.7666 24.8239 28.3344 54.6678 28.3344 54.6678"
      stroke="white"
      strokeWidth="0.00142857"
      strokeMiterlimit="10"
    />
    <path
      d="M36.5433 22.103C36.4198 24.8831 35.9252 54.356 35.9252 54.356"
      stroke="white"
      strokeWidth="0.00142857"
      strokeMiterlimit="10"
    />
    <path
      d="M43.9645 21.8594C43.9638 24.764 44.0881 53.9895 44.0881 53.9895"
      stroke="white"
      strokeWidth="0.00142857"
      strokeMiterlimit="10"
    />
    <path
      d="M51.2539 21.7324C51.1311 24.2666 51.3776 53.9862 51.3776 53.9862"
      stroke="white"
      strokeWidth="0.00142857"
      strokeMiterlimit="10"
    />
    <path
      d="M57.6808 21.7327C57.8051 24.3279 58.7934 53.6162 58.7934 53.6162"
      stroke="white"
      strokeWidth="0.00142857"
      strokeMiterlimit="10"
    />
    <path
      d="M65.2124 29.7449C61.1035 29.808 14.299 29.8902 14.299 29.8902"
      stroke="white"
      strokeWidth="0.00142857"
      strokeMiterlimit="10"
    />
    <path
      d="M66.0786 37.6726C62.1243 37.7961 13.8057 37.9198 13.8057 37.9198"
      stroke="white"
      strokeWidth="0.00142857"
      strokeMiterlimit="10"
    />
    <path
      d="M66.9448 46.0809C62.7424 46.2038 13.3117 45.9573 13.3117 45.9573"
      stroke="white"
      strokeWidth="0.00142857"
      strokeMiterlimit="10"
    />
    <path
      d="M21.6602 47.8555C21.8461 48.3025 21.7541 48.5854 22.0894 48.9701C22.4246 49.3558 22.6264 49.5862 22.842 49.601C23.0576 49.6159 24.4352 49.5654 25.2273 49.6208C26.0185 49.6752 26.6663 49.7197 26.7138 50.0846C26.7612 50.4496 26.7464 50.6652 26.1659 50.6988C25.5844 50.7304 24.366 50.5752 24.1454 50.6315C23.9249 50.6889 23.1377 50.5623 23.4729 50.947C23.8072 51.3327 24.545 52.291 24.7724 52.2851C25.1532 52.2752 26.5545 52.3603 27.0648 52.3513C27.9153 52.3385 28.7312 50.9826 28.7243 50.2953C28.7174 49.6099 28.1329 48.3728 27.3467 48.2462C26.5595 48.1196 24.2562 47.9613 23.7528 47.9267C23.2484 47.8921 21.6602 47.8555 21.6602 47.8555Z"
      fill="#FF3602"
    />
    <path
      d="M36.9452 23.8506C37.1311 24.2976 37.0392 24.5804 37.3744 24.9651C37.7097 25.3508 37.9114 25.5813 38.127 25.5961C38.3426 25.6109 39.7202 25.5605 40.5124 25.6159C41.3036 25.6693 41.9513 25.7138 41.9988 26.0797C42.0463 26.4446 42.0314 26.6602 41.4509 26.6929C40.8694 26.7255 39.651 26.5692 39.4305 26.6266C39.2099 26.684 38.4227 26.5574 38.758 26.9421C39.0923 27.3268 39.83 28.2861 40.0575 28.2801C40.4382 28.2703 41.8396 28.3553 42.3499 28.3464C43.2004 28.3326 44.0163 26.9777 44.0094 26.2894C44.0024 25.605 43.418 24.3678 42.6317 24.2412C41.8445 24.1146 39.5412 23.9564 39.0379 23.9218C38.5335 23.8872 36.9452 23.8506 36.9452 23.8506Z"
      fill="#FF3602"
    />
    <path
      d="M36.7023 40.3342C36.908 40.7446 36.8407 41.0176 37.1829 41.3588C37.5261 41.7 37.7318 41.9047 37.9365 41.9047C38.1412 41.9037 39.4397 41.7643 40.1913 41.7623C40.9439 41.7613 41.559 41.7593 41.6283 42.1015C41.6975 42.4437 41.6975 42.6484 41.1516 42.7186C40.6037 42.7878 39.4427 42.7226 39.237 42.7908C39.0322 42.86 38.2796 42.7928 38.6228 43.135C38.965 43.4752 39.7265 44.3316 39.9411 44.3108C40.3001 44.2762 41.6293 44.2634 42.1109 44.2208C42.9139 44.1506 43.5953 42.8155 43.5429 42.1658C43.4895 41.519 42.8546 40.3886 42.102 40.3214C41.3504 40.2551 39.1628 40.2601 38.6841 40.261C38.2065 40.262 36.7023 40.3342 36.7023 40.3342Z"
      fill="#FF3602"
    />
    <path
      d="M36.9452 48.5102C37.1509 48.9206 37.0836 49.1936 37.4258 49.5357C37.769 49.8769 37.9747 50.0816 38.1794 50.0806C38.3841 50.0806 39.6826 49.9402 40.4352 49.9392C41.1868 49.9373 41.802 49.9353 41.8712 50.2775C41.9404 50.6196 41.9404 50.8243 41.3945 50.8946C40.8476 50.9638 39.6856 50.8985 39.4799 50.9668C39.2752 51.036 38.5236 50.9697 38.8658 51.3109C39.2089 51.6521 39.9694 52.5085 40.184 52.4868C40.543 52.4522 41.8732 52.4393 42.3548 52.3968C43.1578 52.3266 43.8383 50.9915 43.7858 50.3417C43.7324 49.695 43.0975 48.5646 42.3449 48.4983C41.5933 48.4311 39.4057 48.436 38.9271 48.437C38.4494 48.439 36.9452 48.5102 36.9452 48.5102Z"
      fill="#FF3602"
    />
    <path
      d="M51.0788 40.1863C51.2855 40.5987 51.2173 40.8737 51.5614 41.2168C51.9056 41.559 52.1123 41.7647 52.319 41.7647C52.5247 41.7637 53.8301 41.6243 54.5857 41.6223C55.3412 41.6203 55.9593 41.6193 56.0285 41.9625C56.0988 42.3057 56.0988 42.5124 55.5499 42.5826C55 42.6518 53.8321 42.5865 53.6264 42.6558C53.4207 42.724 52.6641 42.6577 53.0083 43.0009C53.3524 43.3431 54.1179 44.2045 54.3345 44.1837C54.6944 44.1481 56.0305 44.1352 56.5151 44.0927C57.3211 44.0215 58.0055 42.6795 57.9531 42.0268C57.8997 41.377 57.2618 40.2407 56.5062 40.1735C55.7497 40.1072 53.5512 40.1122 53.0706 40.1132C52.5899 40.1141 51.0788 40.1863 51.0788 40.1863Z"
      fill="#FF3602"
    />
    <path
      d="M22.0405 32.1056C22.2472 32.518 22.1799 32.7929 22.5241 33.1361C22.8682 33.4783 23.0749 33.684 23.2806 33.684C23.4863 33.683 24.7918 33.5426 25.5473 33.5416C26.3029 33.5396 26.922 33.5376 26.9912 33.8818C27.0604 34.2249 27.0614 34.4316 26.5116 34.5009C25.9617 34.5711 24.7937 34.5048 24.588 34.575C24.3823 34.6433 23.6268 34.577 23.9709 34.9192C24.3151 35.2624 25.0796 36.1228 25.2961 36.103C25.6561 36.0674 26.9922 36.0535 27.4768 36.011C28.2838 35.9408 28.9672 34.5988 28.9147 33.9461C28.8613 33.2963 28.2235 32.16 27.4679 32.0928C26.7123 32.0255 24.5129 32.0314 24.0322 32.0324C23.5516 32.0334 22.0405 32.1056 22.0405 32.1056Z"
      fill="#FF3602"
    />
    <path
      d="M10.2347 59.095C9.97982 59.3486 9.77104 61.5924 9.69724 63.4124L71.4684 63.4127C71.1211 61.4619 70.3896 58.9011 70.3896 58.9011C70.3896 58.9011 10.6219 58.7069 10.2347 59.095Z"
      fill="#DDDDD3"
    />
  </Svg>
)

export default Flexible
